var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"project-container",attrs:{"fluid":""}},[_c('v-row',[(_vm.renderedOrder==1)?_c('ProjectLeftbar',{on:{"setMode":_vm.setMode}}):_vm._e(),_c('v-col',{staticClass:"pa-0"},[_c('ProjectContent',{attrs:{"filterMode":_vm.mode},on:{"rendered":function($event){_vm.renderedOrder=1}}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }